// Display labels for segment-domain enums — single source of truth, shared by
// the segment/distribution/destination/audience surfaces. Framework-agnostic by
// the features/*/types layer rule (no React imports).

import type { DistributionSchedule, ModelingPriority, RunStatus } from './types'

// Run status → badge label + Mantine color.
export const RUN_STATUS_META: Record<
    RunStatus,
    { label: string; color: string }
> = {
    queued: { label: 'Queued', color: 'gray' },
    running: { label: 'Running', color: 'info' },
    succeeded: { label: 'Succeeded', color: 'success' },
    partial: { label: 'Partial', color: 'warning' },
    failed: { label: 'Failed', color: 'error' },
}

export const SCHEDULE_LABEL: Record<DistributionSchedule, string> = {
    once: 'One-time',
    weekly: 'Weekly',
}

export const MODELING_PRIORITY_LABEL: Record<ModelingPriority, string> = {
    balanced: 'Balanced',
    similarity: 'Similarity',
    reach: 'Reach',
}
